import { removeAccents } from '../../../helpers/common'

export const filterDropList = (dropList, inputValue = '') => {
  if (!dropList || !dropList.length) return []
  const val = removeAccents(inputValue.trim().toLowerCase())

  return dropList.filter((item) => {
    const label = removeAccents(item.label.toLowerCase())
    return label.includes(val)
  })
}

export const getPortfolioLabel = (allPortfolio, portfolioId) => {
  if (portfolioId === undefined) return ''

  const label = allPortfolio.find(
    (item) => item.value === portfolioId && item.value,
  )?.label

  return label ?? ''
}
